import { cn } from '@/lib/utils'
import { useLocation } from 'react-router-dom'
import NavCollapsible from './NavCollapsible'
import { useSideBarContext } from './SideBarProvider'
import { NavLinks } from './type'

const year = new Date().getFullYear()

type Props = {
  navs: NavLinks[]
}

export default function SideBar({ navs }: Props) {
  const { isOpen, setIsOpen } = useSideBarContext()
  const { pathname } = useLocation()

  return (
    <aside
      className={cn(
        'hidden w-full h-[calc(100vh-60px)] z-50 border-r fixed left-0 bg-gray-50 transition-[max-width] md:block top-[60px]',
        {
          'max-w-[72px]': !isOpen,
          'md:max-w-[220px] lg:max-w-60': isOpen,
        },
      )}
    >
      <div className="flex h-full flex-col">
        <div className="flex-1 overflow-y-auto p-4">
          <nav className="flex flex-col items-stretch overflow-y-auto overflow-x-hidden text-sm font-medium">
            {navs.map(({ sub, roles, highlight, ...rest }) => (
              <NavCollapsible
                key={rest.to ?? rest.label}
                sub={sub}
                roles={roles}
                highlight={highlight}
                {...rest}
              />
            ))}
          </nav>
        </div>
      </div>
    </aside>
  )
}
